import { useState } from "react";
import { apiGet } from "../../services/api.service";

export interface AccountDeletionBlocker {
	type: 'booked_events' | 'applied_events' | 'group_memberships';
	count: number;
	details: any[];
	message: string;
	actionRequired: string;
}

export interface AccountDeletionValidation {
	canDelete: boolean;
	blockers: AccountDeletionBlocker[];
	message: string;
}

export interface AccountDeletionValidationResponse {
	canDelete: boolean;
	message: string;
	blockers: AccountDeletionBlocker[];
	extraId: number;
}

/**
 * Hook for validating if an account can be deleted
 */
export function useAccountDeletionValidation() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	const validateAccountDeletion = async (extraId?: number): Promise<AccountDeletionValidationResponse | null> => {
		try {
			setLoading(true);
			setError(null);

			// Get current user ID from localStorage if not provided
			let targetExtraId = extraId;
			if (!targetExtraId) {
				const userStr = localStorage.getItem('currentUser');
				const currentUser = userStr ? JSON.parse(userStr) : null;
				targetExtraId = currentUser?.extraId;
			}

			if (!targetExtraId) {
				throw new Error('Benutzer-ID nicht gefunden. Bitte loggen Sie sich erneut ein.');
			}

			const response = await apiGet<AccountDeletionValidationResponse>(
				`/extras/validate-deletion/${targetExtraId}`
			);

			// Extract the data from the ApiResponse wrapper
			if (response && response.data) {
				return response.data;
			}
			return response as unknown as AccountDeletionValidationResponse;
		} catch (err) {
			const error =
				err instanceof Error
					? err
					: new Error("Validierung der Account-Löschung fehlgeschlagen");
			setError(error);
			throw error;
		} finally {
			setLoading(false);
		}
	};

	return {
		validateAccountDeletion,
		loading,
		error,
	};
}